import { render, staticRenderFns } from "./WoodText.vue?vue&type=template&id=3aa78dad&scoped=true&"
import script from "./WoodText.vue?vue&type=script&lang=js&"
export * from "./WoodText.vue?vue&type=script&lang=js&"
import style0 from "./WoodText.vue?vue&type=style&index=0&id=3aa78dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa78dad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
